"use client";

import { motion } from "motion/react";

export const AssistantDialog = ({ text }: { text: string }) => {
  return (
    <div className="flex items-start p-2.5 gap-3">
      <span className="flex min-w-5 w-5 h-0.5 bg-[#fdcc0b] mt-[14px] rounded-full " />
      <motion.div layout className="text-lg font-medium text-[#5b5540]">
        {text.split("").map((letter, i) => (
          <motion.span
            key={text[0] + letter + i}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2, delay: i * 0.03 }}
          >
            {letter}
          </motion.span>
        ))}
      </motion.div>
    </div>
  );
};
